import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Enrollment, type EnrollmentAction } from '../brokers/types'

export function useSendEnrollmentAction ({
  enrollmentId,
}: {
  enrollmentId: string;
}) {
  return useMutation<Enrollment, GrapeAPIErrorType, EnrollmentAction>({
    mutationFn: async (action: EnrollmentAction) => {
      const response = await fetchWithHeaders(
        `/api/web/brokers/unprocessed_enrollments/${enrollmentId}/action`,
        {
          method: 'POST',
          body: JSON.stringify({ action }),
        }
      )

      const responseJson = await response.json()
      if (!response.ok) {
        const errors = responseJson
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }

      return responseJson
    },
  })
}
